'use strict';

import Promise from 'bluebird';

export function BorneFactory($http, $location, $rootScope, $interval, $timeout, $filter, toastr) {
	'ngInject';

	var Borne = {
	};
	var interval

	//function that load every needed informations to build the kiosk workflow
	Borne.load = function (id, callback) {
		return new Promise(function (resolve, reject) {
			return $http.get(`/api/postes/fetchWithId/${id}`).then(function(resp){
				Borne.Poste = resp.data;
				Borne.Poste.availableLanguages = [];
				Borne.Poste.collecte = {};
				Borne.Poste.Session = {};
	      _.forEach(_.map(resp.data.Site.langues, 'id'), function(langueSite){
	        _.forEach(resp.data.langues, function(languePoste){
	          if(langueSite == languePoste) Borne.Poste.availableLanguages.push(_.find(Borne.Poste.Site.langues, ['id', languePoste]));
	        })
	      })
				Borne.Poste.Langue = Borne.Poste.availableLanguages[0];
				Borne.Poste.returnToMain = function(){
					Borne.Poste.collecte = {};
					Borne.Poste.Session = {};
					$interval.cancel(Borne.timeSpentInterval);
					Borne.Poste.selectedCategorie = undefined;
					Borne.stopTimer();
					$location.path('/borne/' + Borne.Poste._id);
				}
				return resolve()
			}).catch((resp) => {
				console.log(resp);
      	$location.path('/borne/admin');
			})
		});
	}

	//function that change the current language of the kiosk
	Borne.changeLanguage = function(langue){
		Borne.Poste.Langue = Borne.Poste.availableLanguages[Borne.Poste.availableLanguages.indexOf(langue)]
	}

	//function that start the timer of the selected category
	Borne.startTimer = function(){
		if(Borne.timerStarted) return;
		Borne.timerStarted = true;
		Borne.Poste.timer = Borne.Poste.selectedCategorie.standbyTimer;
		interval = setInterval(function(){
			if(Borne.Poste.timer != 0) {
				Borne.Poste.timer -= 1000;
				console.log(Borne.Poste.timer);
				if(Borne.Poste.timer <= (Borne.Poste.selectedCategorie.standbyTimer/4)) {
					// toastr.warning($filter('dynamic')(Borne.Poste.Langue.dictionnary.general.deconnexion), {timeOut: Borne.Poste.timer, progressBar: false});
					// $timeout(() => {toastr.clear()},1000)
				}
			} else {
				Borne.Poste.returnToMain();
				$('.modal-backdrop').hide();
				$rootScope.$apply();
			}
		}, 1000)
	}

	//function that stop the timer
	Borne.stopTimer = function(){
		clearInterval(interval);
		Borne.timerStarted = false;
	}

	//function that reset the timer
	Borne.resetTimer = function(){
		if(Borne.Poste.selectedCategorie) Borne.Poste.timer = Borne.Poste.selectedCategorie.standbyTimer
	}

	//function that reset the timer
	Borne.startRecord = function(){
		Borne.timeSpentInterval = $interval(function(){
			if(Borne.Poste.Session.timeSpent) Borne.Poste.Session.timeSpent ++
			else Borne.Poste.Session.timeSpent = 1;
			console.log(Borne.Poste.Session.timeSpent)
		},1000)
	}

	//On touch event reset the timer
	window.addEventListener('touchstart', function() {
		// toastr.clear();
		if(Borne.timerStarted && $location.path().startsWith('/borne')) Borne.resetTimer()
	});

	//On click event reset the timer
	window.addEventListener('click', function() {
		// toastr.clear();
	  if(Borne.timerStarted && $location.path().startsWith('/borne')) Borne.resetTimer()
	});

	return Borne;
}


// WEBPACK FOOTER //
// ./client/app/borne/borne.factory.js